<div align="left">
  <form [formGroup]="craneSelectionForm" (ngSubmit)="onSubmit()" id="craneSelectionForm">
    <fieldset>
      <legend
        i18n="
          System of unit|The heading for system of unit the cranes should be
          shown for in crane selection@@HeadingSystemOfUnit
        "
      >
        System of Unit
      </legend>
      <input
        type="radio"
        id="imperial"
        formControlName="systemOfUnit"
        value="U"
        (change)="aendereEinheitenSystem('U')"
      />
      <label
        for="imperial"
        i18n="Label imperial|The label for imperial unit@@ImperialUnit"
        >Imperial</label
      >
      <br />
      <input
        type="radio"
        id="metric"
        formControlName="systemOfUnit"
        value="M"
        (change)="aendereEinheitenSystem('M')"
      />
      <label for="metric" i18n="Label metric|Label for metric unit@@MetricUnit"
        >Metric</label
      >
      <br />
    </fieldset>
    <br />
    <fieldset>
      <legend
        i18n="
          Heading load charts|Heading for area where kind of load chart is
          choosen@@HeadingLoadChartChoose
        "
      >
        Load Charts
      </legend>
      <input
        type="radio"
        id="MAXbase"
        formControlName="Berechnungsart"
        value="2"
        (change)="aendereKranArt()"
      />
      <label
        for="MAXbase"
        i18n="MAXbase|Label for MAXbase radio Button@@LabelMAXbase"
        >MAXbase</label
      >
      <input
        type="radio"
        id="360Grad"
        formControlName="Berechnungsart"
        value="0"
        (change)="aendereKranArt()"
      />
      <label
        for="360Grad"
        i18n="Label 360°|Label for radio button 360°@@Label360Degree"
        >360° table</label
      >
      <div
        id="falscherTabellenTyp"
        *ngIf="falscherTabellenTyp"
        i18n="
          Wrong type|Text if a wrong table type is
          choosen@@WrongTableTypeChoosen
        "
      >
        Please choose a correct type
      </div>
    </fieldset>
    <br />
    <fieldset>
      <legend
        i18n="
          Heading model|Heading for list of crane models available with choosen
          table type and system of unit@@HeadingModel
        "
      >
        Model
      </legend>
      <select
        id="selectedCrane"
        formControlName="craneModel"
        [size]="groesseKranAuswahl"
        (change)="pruefeKranAuswahl()"
      >
        <option
          *ngFor="let crane of cranes"
          [value]="crane.datenbank"
          [selected]="crane.datenbank == appStatus['kranDatenbankNamen']"
          >{{ crane.name }}</option
        >
      </select>
      <div class="infobereich bstooltip">
        <!--Info Icon-->
        <div class="info-icon" id="info-icon"></div>
        <div
          class="tooltiptext attop"
          style="width:240px; text-align:left;margin-left: -120px;"
        >
          <table>
            <tr>
              <td>_HW2</td>
              <td i18n="lifting unit 2|Tooltip text for _HW2@@TooltipHW2">
                lifting unit 2
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div
        id="keinKranGewaehlt"
        *ngIf="noCraneSelected && submitted"
        i18n="
          No crane selected|Message if no crane was selected@@NoCraneSelected
        "
      >
        Please select a crane.
      </div>
    </fieldset>
    <a class="css-button" form="craneSelectionForm" (click)="goBack()">
			<span class="css-button-text"><ng-container i18n="Back button|Label for back button in selection dialog@@Back">Back</ng-container></span>
		</a>

    <a class="css-button" form="craneSelectionForm" (click)="onSubmit()">
			<span class="css-button-text"><ng-container i18n="continue button|Label for continue button in crane selection@@Continue">Continue</ng-container></span>
		</a>
    <br />
    <br />
  </form>
</div>
